import { WithWorkspaceId } from '~/types/common';
import { Assistant } from '~/types/resources';
import { integrationAssistantApi } from '~/utils/api';

export const createAssistant = async ({
  workspaceId,
  name,
  robotId,
  task,
}: { name: string; robotId: string; task: string } & WithWorkspaceId) =>
  integrationAssistantApi.post<Assistant>(`/workspaces/${workspaceId}/assistants`, {
    name,
    robotId,
    task,
  });

export const getAssistant = async ({ workspaceId, id }: { id: string } & WithWorkspaceId) =>
  integrationAssistantApi.get<Assistant>(`/workspaces/${workspaceId}/assistants/${id}`);

export const deleteAssistant = async ({ workspaceId, id }: { id: string } & WithWorkspaceId) =>
  integrationAssistantApi.delete<Assistant>(`/workspaces/${workspaceId}/assistants/${id}`);

export const updateAssistant = async ({
  workspaceId,
  id,
  assistant,
}: { id: string; assistant: Assistant } & WithWorkspaceId) =>
  integrationAssistantApi.put<Assistant, { message: string; subCode: string }>(
    `/workspaces/${workspaceId}/assistants/${id}`,
    {
      ...assistant,
    },
  );

export const listAssistants = async ({ workspaceId }: WithWorkspaceId) =>
  integrationAssistantApi.get<Assistant[]>(`/workspaces/${workspaceId}/assistants`);
